import React from 'react';
import icon from 'assets/ppsc_images/CementLogo.png';

const Icon = ({ width }) => <img src={icon} alt="CementingDesign" width={width || '25'} />;

export default Icon;
